import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { PlusIcon, Trash } from 'lucide-react';
import { InputNumberFormat, Button, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuItem, DefaultTable, Input, ButtonIcon } from 'twyne-new.ui'

import ConfirmationPopover from 'components/ConfirmationPopover';
import { useSiteStore } from '../store';

const propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
};

export default class SiteVerifications extends React.Component {

  state = {
    data: [],
    verifications: [],
  }

  defaultCost = {
    email: 0.003,
    phone: 0.009,
    postal: 0.004,
    fraud: 0,
  }

  columns = [{
    dataField: 'cmsVerification',
    text: 'Description',
    formatter: cmsVerification => <div className='pr-4' >
      <Input disabled value={cmsVerification.name} />
    </div>,
  }, {
    dataField: 'cost',
    text: 'Cost',
    formatter: (cost, { cmsVerification: { active, type } }, idx) => {
      cost = (cost === null || cost === undefined) ? this.defaultCost[type] : cost
      return <this.CostInput cost={cost} onChange={this.handleChangeVerification(idx)} disabled={!active} />
    }
  }, {
    dataField: 'actions',
    text: '',
    className: 'w-8',
    formatter: (_, { id }, idx) => {
      return <div key={id}>
        <ConfirmationPopover
          asChild
          title={<span>Are you sure you want do this?</span>}
          id={`${id}`}
          target={<div className='flex items-center w-full h-8'>
            <ButtonIcon content='Delete'> <Trash size={16} /> </ButtonIcon>
          </div>}
        >
          <p>There are allocations that have this verification enabled. Deleting this verification will also delete this verification from an allocation.</p>
          <Button className='mt-2 flex justify-center' block color="danger" onClick={this.handleChangeVerification(idx, true)}>Yes, I am sure</Button>
        </ConfirmationPopover>
      </div>
    }
  }]

  componentWillMount() {
    this.loadData()
  }

  loadData = () => {
    const { data } = this.props

    this.setState({
      data: data.map((item) => {
        item.index = uniqueId()
        return item
      })
    })
  }

  isAdded = verificationId => {
    const { data } = this.props
    return data.some(({ cmsVerificationId }) => cmsVerificationId == verificationId)
  }

  addOption = (cmsVerification) => {
    this.handleChange(data => {
      data.push({ cmsVerificationId: cmsVerification.id, cmsVerification, index: uniqueId() })
    })
  }

  handleChangeVerification = (idx, remove = false) => (key, value) => {
    this.handleChange(data => {
      if (remove)
        data.splice(idx, 1)
      else
        data[idx][key] = value
    })
  }

  handleChange = (changes) => {
    const { onChange } = this.props
    const { data } = this.state
    changes(data)
    onChange(data)
  }

  DropdownItem = ({ data }) => {
    const { name, active, id } = data
    const added = this.isAdded(id)

    return <DropdownMenuItem disabled={!active || added} onClick={() => !added && this.addOption(data)}>
      {name} {!active ? "(inactive)" : ''}
    </DropdownMenuItem>
  }

  AddButton = () => {
    const { listVerifications } = useSiteStore()
    const { verifications } = this.state

    const loadVerifications = useCallback(async () => {
      const verifications = await listVerifications()
      this.setState({ verifications })
    }, [listVerifications])

    useEffect(() => {
      loadVerifications()
    }, [loadVerifications])

    return <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button color='accent' size='sm' className='flex items-center'>
            <PlusIcon size={12} />
            Add
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {verifications.map(item => <this.DropdownItem key={item.id} data={item} />)}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  }

  CostInput = ({ cost, onChange, disabled }) => {
    const [value, setValue] = useState('')

    useEffect(() => {
      setValue(cost)
      onChange('cost', cost)
    }, [cost])

    return <div className='pr-4'>
      <InputNumberFormat
        disabled={disabled}
        thousandSeparator={true}
        prefix={'$ '}
        className={'form-control'}
        placeholder='Cost'
        value={value}
        onValueChange={({ floatValue }) => setValue(floatValue || 0)}
        onBlur={() => onChange('cost', value)}
        required />
    </div>
  }

  Table = ({ data }) => <>
    <DefaultTable
      data={data}
      columns={this.columns}
      rowStyle={(row) => !row.cmsVerification.active ? 'twy-bg-base' : null}
    />
  </>

  render() {
    const { data } = this.state

    return <React.Fragment>
      <this.AddButton />
      <this.Table data={data} />
    </React.Fragment>
  }
}

SiteVerifications.propTypes = propTypes
SiteVerifications.defaultProps = {}
